/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Comms from './Comms/index'
import React from 'react'
import Sections from './Sections/index'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import SyncSectionParams from './SyncSectionParams/index'
import TopBar from './TopBar/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsWhite,'--bc-6-Z1Yf8zk': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<TopBar
{...childProps}
  viewPath={`${viewPath}/TopBar`}
/>
)}
</SentryErrorBoundary>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<Sections
{...childProps}
  viewPath={`${viewPath}/Sections`}
/>
)}
</SentryErrorBoundary>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Comms
{...childProps}
  viewPath={`${viewPath}/Comms`}
/>
)}
</SuspenseBoundary>
<SyncSectionParams
  viewPath={`${viewPath}/SyncSectionParams`}
/>
{children}
</React.Fragment>)
}